<template>
  <div>
    <el-upload
      ref="uploader"
      action="#"
      list-type="picture-card"
      :multiple="mode === 'edit' ? false : true"
      :limit="20"
      :class="[
        'media-uploader',
        formDisabled ? 'is-disabled' : '',
        hideUploadCard ? 'hide-upload' : '',
        extraUpload ? 'extra-upload' : '',
        uploadBasis ? `extra-upload-${uploadBasis}` : ''
      ]"
      :disabled="formDisabled"
      :file-list="mediaForm.mediaList"
      :accept="mediaConfig.accept"
      :http-request="uploadFile"
      :before-upload="beforeUploadFile"
      :before-remove="() => false"
      :on-change="handleFileChange"
      :on-exceed="handleFileExceed"
    >
      <div slot="default" class="upload-btn">
        <i class="el-icon el-icon-plus"></i>
        <p>{{ mediaConfig.fileTips }}</p>
      </div>
      <div slot="file" slot-scope="{file}" class="image-slot">
        <div class="file-box">
          <div class="image-box">
            <el-image :src="file.url" fit="contain">
              <div slot="error" class="error-icon">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <span v-if="!formDisabled" class="el-upload-list__item-actions" :style="file.status === 'uploading' ? 'opacity:1' : ''">
              <span v-if="file.status === 'success'" class="el-upload-list__item-delete" @click="removeFile(file)">
                <i class="el-icon-delete"></i>
              </span>
              <span v-if="file.status === 'success' && mode === 'edit'" class="el-upload-list__item-delete" @click="handleReUpload">
                <i class="el-icon-upload" style="font-size:22px"></i>
              </span>
              <el-progress
                v-if="file.status === 'uploading'"
                type="circle"
                color="#f78400"
                text-color="#fff"
                :width="100"
                :percentage="file.percentage"
              ></el-progress>
            </span>
          </div>
          <el-form-item
            label-width="0"
            style="margin-bottom:0"
            :prop="`mediaList.${getFileIndex(file)}.mediaName`"
            :rules="[{ required: true, message: '请填写素材名称' }]"
          >
            <el-input v-model="file.mediaName" clearable size="small" show-word-limit maxlength="45" placeholder="素材名称"></el-input>
          </el-form-item>
          <div v-if="extraUpload" class="box-type">素材</div>
        </div>
        <!-- 弹窗引导图 -->
        <el-form-item v-if="needGuideImg" label-width="0">
          <GuideImgUploader
            :mediaItem="file"
            :guideImgConfig="guideImgConfig"
            :spaceId="mediaForm.spaceId"
            :disabled="formDisabled"
          />
        </el-form-item>
        <!-- 封面图 -->
        <el-form-item
          v-if="needCoverImg"
          label-width="0"
          class="min-icon-item"
        >
          <CoverImgUploader
            :mediaItem="file"
            :coverImgConfig="coverImgConfig"
            :spaceId="mediaForm.spaceId"
            :disabled="formDisabled"
          />
        </el-form-item>
        <!-- 背景图 -->
        <el-form-item
          v-if="showBgImage"
          label-width="0"
          class="min-icon-item"
        >
          <BgImageUploader
            :mediaItem="file"
            :bgImageConfig="bgImageConfig"
            :spaceId="mediaForm.spaceId"
            :disabled="formDisabled"
          />
        </el-form-item>
      </div>
    </el-upload>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import GuideImgUploader from './GuideImgUploader.vue'
import CoverImgUploader from './CoverImgUploader.vue'
import BgImageUploader from './BgImageUploader.vue'

export default {
  components: {
    GuideImgUploader,
    CoverImgUploader,
    BgImageUploader
  },
  props: {
    mode: { type: String, default: 'add' },
    mediaForm: { type: Object, default: () => ({}) },
    showDuration: { type: Boolean },
    adSpaceModel: { type: Object },
    mediaConfig: { type: Object },
    guideImgConfig: { type: Object },
    coverImgConfig: { type: Object },
    bgImageConfig: { type: Object }
  },
  data() {
    return {
      curGuideIcon: ''
    }
  },
  computed: {
    formDisabled() {
      return this.mode === 'edit' && this.mediaForm.checkStatus !== 0
    },
    hideUploadCard() {
      return this.mode === 'edit' && this.mediaForm.mediaList.length > 0
    },
    getFileIndex(file) {
      return function (file) {
        return this.mediaForm.mediaList.findIndex(item => item.uid === file.uid)
      }
    },
    needGuideImg() {
      return this.guideImgConfig.limitSize > 0 && !(this.formDisabled && this.mediaForm.mediaList.every(item => !item.guideIcon))
    },
    needCoverImg() {
      return (
        this.adSpaceModel.brandIcon &&
        (this.mediaForm.mediaClassId === 2 ||
          (this.mediaForm.mediaClassId === 1 &&
            this.adSpaceModel.spaceNo === 'CCADTV10058'))
      )
    },
    showBgImage() {
      return this.adSpaceModel.bgImage === 1 && this.mediaForm.mediaClassId === 2
    },
    extraUpload() {
      return this.needGuideImg || this.needCoverImg || this.showBgImage
    },
    uploadBasis() {
      return this.needGuideImg * 1 + this.needCoverImg * 1 + this.showBgImage * 1
    }
  },
  methods: {
    async beforeUploadFile(file) {
      let errorMessage = ''
      let webpWidth
      let webpHeight
      if (file.type === 'image/webp') {
        const resolution = await this.getWebpResolution(file)
        webpWidth = resolution.width
        webpHeight = resolution.height
      }
      const fileIndex = this.mediaForm.mediaList.findIndex(item => item.uid === file.uid)
      if (fileIndex > -1) {
        this.mediaForm.mediaList[fileIndex].webpWidth = webpWidth
        this.mediaForm.mediaList[fileIndex].webpHeight = webpHeight
      }
      if (this.mediaForm.mediaClassId === 2 || this.mediaForm.mediaClassId === 4) {
        const isLt10M = file.size / 1024 < this.mediaConfig.limitSize
        const tsFile = file.name.substring(file.name.length - 3, file.name.length)
        if (['video/mp4'].indexOf(file.type) === -1 && tsFile !== '.ts') {
          errorMessage = '请上传正确的视频格式'
        } else if (!isLt10M) {
          errorMessage = `视频大小不能超过${this.mediaConfig.limitSize}K`
        }
      } else if (this.mediaForm.mediaClassId === 5) {
        // 处理3d zip包
        let size = this.mediaConfig.limitSize
        const zipSize = file.size / 1024 < size
        const zipFile = file.name.substring(file.name.length - 3, file.name.length)
        if (!zipSize) {
          errorMessage = `上传zip包大小不能超过${size}K`
        } else if (!zipFile.includes('zip')) {
          errorMessage = '请上传正确的zip格式'
        }
      } else {
        const isLimt = file.size / 1024 < this.mediaConfig.limitSize
        let index = file.type.indexOf('/')
        let format = file.type.substring(index + 1)
        if (!(this.mediaConfig.format.includes(format) || file.type === 'image/jpeg')) {
          errorMessage = `图片只能是 ${this.mediaConfig.format} 格式`
        } else if (!isLimt) {
          errorMessage = `图片大小不能超过${this.mediaConfig.limitSize}K`
        }
      }
      if (errorMessage !== '') {
        this.removeFile(file)
        this.$message.error(`【${file.name}】${errorMessage}`)
      }
      return errorMessage === ''
    },
    handleFileChange(file, list) {
      if (this.mode === 'edit') {
        this.mediaForm.mediaList = [file]
        if (this.needGuideImg && this.curGuideIcon) {
          this.mediaForm.mediaList[0].guideIcon = this.curGuideIcon
        }
      } else {
        this.mediaForm.mediaList = list || []
      }
    },
    handleFileExceed() {
      this.$message.error('最多允许上传20个文件')
    },
    uploadFile(paramsFile) {
      const self = this
      let fileReader = new FileReader()
      let dataFile = paramsFile.file
      let fileItem = this.mediaForm.mediaList.find(item => item.uid === dataFile.uid)
      if (!fileItem) {
        return
      }
      fileItem.status = 'uploading'
      fileReader.readAsBinaryString(dataFile)
      // 文件读取完毕之后的处理
      fileReader.onload = function (e) {
        let spark = new SparkMD5()
        fileItem.md5 = spark.appendBinary(e.target.result).end()
        fileItem.percentage = 0
        if (fileItem.name) {
          let nameFragments = fileItem.name.split('.')
          nameFragments.pop()
          self.$set(fileItem, 'mediaName', nameFragments.join('.').substring(0, 45))
        }
        fileItem.intervalId = setInterval(() => {
          if (fileItem.percentage < 99) {
            fileItem.percentage += 5
          }
        }, 1560)
        self.requestUpload(fileItem, paramsFile)
      }
    },
    requestUpload(fileItem, paramsFile) {
      this.$service
        .uploadFile({
          file: paramsFile.file,
          md5: fileItem.md5,
          spaceId: this.mediaForm.spaceId,
          mediaClassId: this.mediaForm.mediaClassId,
          width: fileItem.webpWidth,
          height: fileItem.webpHeight,
        })
        .then(res => {
          if (res.code === 0) {
            fileItem.url = res.data.mediaIconUrl
            fileItem.mediaIcon = res.data.mediaIcon
            fileItem.originalMediaPath = res.data.originalMediaPath
            if (res.data.duration) {
              if (this.showDuration && this.mediaForm.mediaClassId === 1) {
                this.mediaForm.duration = res.data.duration
              }
              fileItem.duration = res.data.duration
            }
            fileItem.status = 'success'
          } else {
            this.$message.error(`【${fileItem.name}】${res.message}`)
            fileItem.status = 'error'
            this.removeFile(fileItem)
          }
          window.clearInterval(fileItem.intervalId)
        })
        .catch(e => {
          this.removeFile(fileItem)
          window.clearInterval(fileItem.intervalId)
        })
    },
    removeFile(file) {
      const fileIndex = this.mediaForm.mediaList.findIndex(fileItem => fileItem.uid === file.uid)
      this.mediaForm.mediaList.splice(fileIndex, 1)
    },
    handleReUpload() {
      if (this.mode === 'edit' && this.needGuideImg && this.mediaForm.mediaList.length) {
        this.curGuideIcon = this.mediaForm.mediaList[0].guideIcon
      }
      this.mediaForm.mediaList = []
      this.$refs.uploader.$refs['upload-inner'].$refs.input.click()
    },
    // 获取webp图片的分辨率
    getWebpResolution(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
          if (reader.readyState === 2) {
            const img = new Image()
            img.src = reader.result
            img.onload = function (e) {
              resolve({ width: this.width, height: this.height })
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.media-uploader
  >>>.el-upload--picture-card
    padding 8px
    width 260px
    height 226px
    background-color #fff
    .upload-btn
      display flex
      flex-flow column nowrap
      justify-content center
      height 196px
      line-height 22px
      font-size 12px
      color #999
      .el-icon
        color #f78400
      p
        margin 4px 0
        word-break break-all
  &.is-disabled >>> >div.el-upload.el-upload--picture-card
    display none
  &.hide-upload >>> >.el-upload--picture-card
    display none
  &.extra-upload >>> >.el-upload--picture-card
    width 280px
    height 256px
  >>>.el-upload-list__item
    width 260px
    height 226px
    transition all .5s
  &.extra-upload >>>.el-upload-list__item
    height 256px
    .file-box
      border 1px solid #c0ccda
      border-radius 4px
      padding 28px 10px 20px
  &.extra-upload-1 >>>.el-upload-list__item
    width 570px
  &.extra-upload-2 >>>.el-upload-list__item
    width 830px
  &.extra-upload-3 >>>.el-upload-list__item
    width 1050px
.box-type
  position absolute
  top 0
  left 0
  width 40px
  height 18px
  line-height 18px
  text-align center
  font-size 12px
  color #fff
  background-color #f78400
  border-radius 4px 0
.image-slot
  display flex
  flex-flow row nowrap
  padding 10px
  >.el-form-item
    margin-left 10px
.file-box
  position relative
  display flex
  flex-flow column nowrap
  justify-content center
  height 100%
  width 260px
  .image-box
    display flex
    position relative
    flex-grow 1
    margin-bottom 10px
    .el-image
      width 100%
      height 138px
      .error-icon
        display flex
        justify-content center
        align-items center
        height 100%
.el-upload-list__item-actions .el-progress
  width 100px
  >>>.el-progress__text
    color #fff
.el-upload-list__item-delete
  margin 0 12px
  &:hover
    color #f78400
.min-icon-item >>>.el-form-item__content
  position relative
  .el-form-item__error
    position absolute
    top calc(100% - 30px)
    left 20px
.el-form-item
  margin-bottom 0
</style>
